import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {HeaderComponent} from '../../header/header.component';
import {HeadersComponent} from '../../devex/headers/headers.component';
import {ConfService} from '../../conf.service';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatSnackBar} from '@angular/material';
import {ContactSalesComponent, ContactSalesData} from '../../home-old/home-old.component';
import {AppComponent} from '../../app.component';
import {LeftpanelComponent} from '../../leftpanel/leftpanel.component';

@Component({
  selector: 'app-collections',
  templateUrl: './collections.component.html',
  styleUrls: ['./collections.component.scss']
})
export class CollectionsComponent implements OnInit {

  constructor(private confPost: ConfService, private dialog: MatDialog, private appComp: AppComponent) { }
  collection = {
    name : '',
    version: '',
    description: '',
    displayname: '',
    category: '',
    partner: '',
    account: '',
    authModel : {},
    apiExecutors : [],
    executorsOrder: [],
    collectionScope: '',
    headers: [],
    queryParams: [],
    pathParams: [],
    createdBy: '',
    updatedBy: ''
  };
  addList: any;
  @ViewChild(HeadersComponent) headerChild: HeadersComponent;
  ngOnInit() {
    this.confPost.getApiExecutorForPartnerAccount(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe (res=> {
      this.addList = res;
    });
  }
  OpenDialog() {
    const dialogRef = this.dialog.open(AddToCollComponent, {
      data: {
        addList: this.addList,
        executorsOrder: this.collection.executorsOrder,
        executors: this.collection.apiExecutors
      }
    });

    dialogRef.afterClosed().subscribe(result => {

    });
  }
  Save() {
    if (this.collection.name === '' || this.collection.version === '') {
      alert('Please enter all mandatory fields and try again');
    } else {
      this.collection.headers = this.headerChild.headersData;
      this.collection.queryParams = this.headerChild.parameterData;
      this.collection.authModel = this.headerChild.authModel1.getAuthModel();
      this.collection.partner = localStorage.getItem('partner');
      this.collection.account = localStorage.getItem('account');
      this.collection.createdBy = localStorage.getItem('account');
      this.collection.updatedBy = localStorage.getItem('account');
      const timestamp = new Date();
      this.collection['lastUpdatedAt'] = timestamp.getTime();
      this.collection['createdAt'] = timestamp.getTime();
      this.confPost.addItemServices1('v1', 'apicollection', this.collection).subscribe(res => {
        alert('Creation Successful');
      }, err => {
        alert('Error. Please try again later');
      });
    }
  }
}



@Component({
  selector: 'add-to-coll',
  templateUrl: './add-to-coll.component.html',
  styleUrls: ['./add-to-coll.component.scss']
})

export class AddToCollComponent implements OnInit {
  constructor(
      public platform: LeftpanelComponent,
      public dialogRef: MatDialogRef<AddToCollComponent>,
      @Inject(MAT_DIALOG_DATA) public data) {
  }
  ngOnInit(): void {
  }
  setAll(completed: boolean, id: number, datas: any) {
    if (completed) {
      this.data.executorsOrder.push( id );
      this.data.executors.push (datas);
    } else {
      const index: number = this.data.executorsOrder.indexOf(id);
      if (index !== -1) {
        this.data.executorsOrder.splice(index, 1);
        this.data.executors.splice(index, 1);
      }
    }
  }
  Save() {
    this.dialogRef.close();
  }
  stringifyjson(val) {
    return JSON.stringify(val);
  }
}


